export default "__VITE_ASSET__BXt9nZ8T__"